import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'
import EditableDisplayField from '../../utils/editable-display-field'

import * as MASKS from '../../utils/input-masks'


const mapStateToProps = (state, ownProps) => {
    return {
        agent: state.adminAgents.find(aa => aa.id === Number(ownProps.params.agentId))
    }
}

const ViewAgent = ({ dispatch, params, agent }) => {
    const agentId = params.agentId

    useEffect(() => {
        if (agentId) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/agents', 'VIEW', agentId)))
        }
    }, [dispatch, agentId])

    if (!agent) {
        return null
    }

    const renderAgentInfo = () => {
        return (
            <div className="box">
                <h2>Agent Information</h2>
                <EditableDisplayField
                    label="First Name"
                    display={`${agent.firstName}`}
                    dataObj={agent}
                    endpoint="admin/agents"
                    fields={[{
                        field: 'firstName',
                        type: 'text',
                        required: true
                    }]} />
                <EditableDisplayField
                    label="Last Name"
                    display={`${agent.lastName}`}
                    dataObj={agent}
                    endpoint="admin/agents"
                    fields={[{
                        field: 'lastName',
                        type: 'text',
                        required: true
                    }]} />
                <EditableDisplayField
                    label="Email"
                    display={`${agent.email}`}
                    dataObj={agent}
                    endpoint="admin/agents"
                    fields={[{
                        field: 'email',
                        type: 'email',
                        required: true
                    }]} />
                <EditableDisplayField
                    label="Phone"
                    display={`${MASKS.phoneMask.resolve(agent.phone)}`}
                    dataObj={agent}
                    endpoint="admin/agents"
                    fields={[{
                        field: 'phone',
                        type: 'text',
                        isFormatted: true,
                        formatMask: MASKS.phoneMask
                    }]} />
            </div>
        )
    }

    const renderCommissionRate = () => {
        return (
            <div className="box mt-4">
                <h2>Commission Rate</h2>
            </div>
        )
    }

    return (
        <div>
            <h1>{agent.firstName} {agent.lastName}</h1>
            {renderAgentInfo()}
            {renderCommissionRate()}
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(ViewAgent))
